import * as React from 'react';
import { generateId } from '@agilepoint/utils-common';
import { IPopupMessageProps } from './popup-message-props';
import { eventManager } from './popup-message-event-manager';

export * from './theme';
export * from './popup-message-host';
export * from './popup-message-props';

export function showPopupMessage(config: IPopupMessageProps) {
    const id = config.id || generateId();
    eventManager.emit('showPopupMessage', { ...config, id });
    return id;
}

export function removePopupMessage(id?: string) {
    eventManager.emit('removePopupMessage', id);
}

export const PopupMessage = React.memo((props: IPopupMessageProps) => {
    const popupId = React.useMemo(() => (props.id || generateId()), [props.id]);
    React.useEffect(() => {
        showPopupMessage({ ...props, id: popupId });
    }, [popupId, props]);
    React.useEffect(() => () => {
        removePopupMessage(popupId);
    }, [popupId]);
    return null;
});

PopupMessage.displayName = 'PopupMessage';
